module.exports = __webpack_public_path__ + "static/media/homepage-main.fd51c04c.webm";